import {Component} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {IBaseBlockComponent} from "../../../../interfaces";
import {TranslocoService} from "@ngneat/transloco";
import {actionUpdateEventsStrings} from "../../../../store/actions/user.actions";
import {BlockBaseComponent} from "../block-base/block-base.component";
import {Lib} from "../../../../../libs/Lib";
import * as _ from "lodash";
import {StoreSelectorsService} from "../../../../services";

@Component({
  selector: 'app-block-event-source',
  templateUrl: './block-event-source.component.html',
  styleUrls: ['./block-event-source.component.css']
})
export class BlockEventSourceComponent extends BlockBaseComponent implements IBaseBlockComponent {
  debouncerFunc;

  constructor(private translocoService: TranslocoService, public override storeSelector: StoreSelectorsService, public override dialog: MatDialog) {
    super(storeSelector, dialog);
    this.debouncerFunc = _.debounce(() => {
      const color = String(Lib.HexToDecimal('000000'));
      this.dispatchSceneItemChanges({
        sceneId: this.sceneId,
        sceneItemId: this.sceneItem.$.id,
        values: [{
          key: 'color',
          value: color,
          storePath: `Data[0].Foo[0].$`
        }]
      });
    }, 100);
  }

  override preInit() {
    super.preInit();
  }

  override initRegisterDynamic() {

    this.uiConfigInit = [
      {
        type: "select",
        label: this.translocoService.translate('general.source', {}, this.translocoService.getActiveLang()),
        name: "source",
        value: "cloud",
        options: ["cloud", "drive", "runtime", "external" , "ifttt", "stringify" ],
        storePath: `Data[0].DataProvider[0].$.source`
      },
      {
        type: "input",                                                
        value: '',
        label: this.translocoService.translate('general.eventName', {}, this.translocoService.getActiveLang()),
        inputType: "text_autocomplete",
        observable: this.storeSelector.getEventsCombined(),
        callBackValue: (item, direction) => this.dispatchEventsAll(),
        name: "eventName",
        storePath: `Data[0].DataProvider[0].$.eventName`
      },
      {
        type: "input",
        value: '',
        label: this.translocoService.translate('general.itemPath', {}, this.translocoService.getActiveLang()),
        inputType: "text",
        name: "itemsPath",
        storePath: `Data[0].DataProvider[0].$.itemsPath`
      },
      {
        type: "input",
        value: '',
        label: this.translocoService.translate('general.resultEventName', {}, this.translocoService.getActiveLang()),
        inputType: "text_autocomplete",
        observable: this.storeSelector.getEventsCombined(),
        callBackValue: (item, direction) => this.dispatchEventsAll(),
        name: "resultEventName",
        storePath: `Data[0].DataProvider[0].$.resultEventName`
      },
      {
        type: "input",
        value: '',                                                 
        label: this.translocoService.translate('general.resultEventParam', {}, this.translocoService.getActiveLang()),
        inputType: "text",
        name: "resultEventParam",
        storePath: `Data[0].DataProvider[0].$.resultEventParam`
      },
      {
        type: "input",
        value: '',
        label: this.translocoService.translate('general.link', {}, this.translocoService.getActiveLang()),
        inputType: "text",
        name: "url",
        storePath: `Data[0].DataProvider[0].$.url`
      },
    ];
  }

  override initApplyStoreToDynamic(applyStoreToDynamic: boolean = false) {
    super.initApplyStoreToDynamic(applyStoreToDynamic);
  }

  override componentInit() {
    super.componentInit();
  }

  override componentStoreUpdates() {
    const events = [];
    super.componentStoreUpdates();
    this.initApplyStoreToDynamic(true);
  }

  dispatchEventsAll() {
    const eventsAll = [];
    if (this.sceneItem.Data[0]?.DataProvider?.[0]?.$?.resultEventName)
      eventsAll.push(this.sceneItem.Data[0].DataProvider[0].$.resultEventName);
    if (this.sceneItem.Data[0]?.DataProvider?.[0]?.$?.eventName)
      eventsAll.push(this.sceneItem.Data[0].DataProvider[0].$.eventName);
    // if (eventsAll.length > 0)
      this.storeSelector.dispatch(actionUpdateEventsStrings({eventsStrings: eventsAll}));
  }

  override submit(formValues) {
    // formValues = removeUndefNulls(formValues);
    return super.submit(formValues);
  }

}


